<style>
.vue-google-map {
    width: 100%;
    height: 100%;
}
</style>

<template>
    <div class="vue-google-map-container">
        <div ref="map" class="vue-google-map"></div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            map: null
        };
    },
    mounted () {
        this.map = new window.google.maps.Map(this.$refs.map, this.options);
        this.$emit('initialized', this.map);
    }
};
</script>
